/**
 *  Sidebar.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system 
import React, { Component } from "react";

// components
import HeaderLinks from "../Header/HeaderLinks.jsx";
import { NavLink } from "react-router-dom";
import imagine from "../../assets/img/sidebar-5.jpg";

// routes
import adminRoutes from "../../routes/admin.jsx";

// style 
//import "./style.css";
//import "./style_SOUL.css";
//import "./style_DCM.css";
import "./style_ADG.css";

class Sidebar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      visible: false
    };
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  activeRoute(routeName){
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }

  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }

  toggleMenu = () => {
    this.setState({ visible: !this.state.visible });
  }

  fixedMenu = () => {
    this.setState({ visible: true });
  }
  
  render() {
    const { width, visible } = this.state;
    const sidebarBackground = {
      background: "#000"
    };

    return (
      <div id="sidebar" className="sidebar">

        <div className="sidebar-background" style={sidebarBackground} />
        <div className="space" />

        <div className="sidebar-wrapper">
          <ul className="nav">
            {width <= 991 ? <HeaderLinks /> : null}
            {adminRoutes.map((prop, key) => {
              if (!prop.redirect && prop.path !== '/follow')
                return (
                  <li className={ prop.upgrade ? "active active-pro" : this.activeRoute(prop.path)} key={key}>
                    <NavLink to={prop.path} className="nav-link" activeClassName="active">
                      <i className={prop.icon} />
                      <p style={{fontWeight: "bold"}}>{prop.name}</p>
                    </NavLink>
                  </li>
                );
              return null;
            })}
            
            <li className="active active-pro">
              <a className="nav-link" aria-current="false">
                <p style={{fontSize: "11px"}}>Versão 1.0.7 - Made in Brazil</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx